/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SSEAnnouncement } from '../models/SSEAnnouncement';
import type { SSEArenaCreated } from '../models/SSEArenaCreated';
import type { SSEArenaFinished } from '../models/SSEArenaFinished';
import type { SSEArenaJoined } from '../models/SSEArenaJoined';
import type { SSEArenaParticipantReady } from '../models/SSEArenaParticipantReady';
import type { SSEArenaRound } from '../models/SSEArenaRound';
import type { SSEArenaStart } from '../models/SSEArenaStart';
import type { SSEArenaUpdate } from '../models/SSEArenaUpdate';
import type { SSECaseUpdate } from '../models/SSECaseUpdate';
import type { SSECoinpaymentsDepositComplete } from '../models/SSECoinpaymentsDepositComplete';
import type { SSECoinpaymentsDepositStatus } from '../models/SSECoinpaymentsDepositStatus';
import type { SSECryptoAddress } from '../models/SSECryptoAddress';
import type { SSEEventType } from '../models/SSEEventType';
import type { SSELiveDrop } from '../models/SSELiveDrop';
import type { SSEOnline } from '../models/SSEOnline';
import type { SSEProfileUpdate } from '../models/SSEProfileUpdate';
import type { SSESafeboxAttempt } from '../models/SSESafeboxAttempt';
import type { SSESafeboxWon } from '../models/SSESafeboxWon';
import type { SSETradeUpdate } from '../models/SSETradeUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SseService {
    /**
     * SSE health check endpoint
     * Health check for SSE (Server-Sent Events) service
     * @returns string SSE service is healthy
     * @throws ApiError
     */
    public static getIsOk(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/is-ok',
        });
    }
    /**
     * Real-time event stream (SSE)
     * Server-Sent Events (SSE) endpoint for real-time updates. Clients can connect to this endpoint
     * to receive live notifications about various platform events including case openings, arena games,
     * deposits, trades, and more.
     *
     * **Connection Requirements:**
     * - Uses cookie authentication (SID session cookie)
     * - Browser automatically sends `Accept: text/event-stream` header when using EventSource API
     * - Browser's Origin header is validated server-side against whitelist
     *
     * **Keep-Alive Mechanism:**
     * - Server sends heartbeat comments (`:heartbeat`) every 30 seconds to prevent timeout
     * - Prevents proxy/CDN/load balancer timeouts that typically occur after 60-120 seconds of inactivity
     *
     * **Event Format:**
     * Each event follows the SSE format:
     * ```
     * event: EVENT_TYPE
     * data: {JSON payload}
     *
     * ```
     *
     * **User-Specific Events:**
     * Some events are targeted to specific users and will only be sent to their connections.
     *
     * @returns any SSE event stream established
     * @throws ApiError
     */
    public static getListen(): CancelablePromise<{
        event?: SSEEventType;
        data?: (SSECoinpaymentsDepositComplete | SSECoinpaymentsDepositStatus | SSESafeboxWon | SSESafeboxAttempt | SSETradeUpdate | SSEArenaCreated | SSEArenaJoined | SSEArenaStart | SSEArenaRound | SSEArenaFinished | SSEArenaUpdate | SSEArenaParticipantReady | SSEAnnouncement | SSEProfileUpdate | SSECryptoAddress | SSELiveDrop | SSECaseUpdate | SSEOnline);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/listen',
        });
    }
}
